import * as types from '@types'
import * as services from '@services/otherInfo'

const state = {
  additional: {},
  sectionId: null,
  customFields: {}
}

const getters = {
  isOtherInfoStepEmpty: ({ customFields }) => !Object.keys(customFields || {}).length
}

const mutations = {
  [types.EMPLOYEE_OTHER_INFO_SYSTEM_FIELDS]: (state, data) => {
    state.sectionId = data?.sectionId
    state.customFields = { ...(data?.customFields || {}) }
  },

  [types.EMPLOYEE_OTHER_INFO]: (state, additional) => {
    state.additional = { ...additional }
  }
}

const actions = {
  [types.EMPLOYEE_OTHER_INFO_SYSTEM_FIELDS]: async ({ commit, getters, dispatch }) => {
    const employeeId = getters.getEmployeeUuid
    const companyId = getters.getCompanyUuid

    const [ err, data ] = await services.getSystemFields({ employeeId, companyId })

    if (!err)
      commit(types.EMPLOYEE_OTHER_INFO_SYSTEM_FIELDS, data)
    else dispatch('FEEDBACKS_ADD', {
      type: 'error',
      message: 'Não foi possível carregar os campos de outras informações.'
    })

    return [ err, data ]
  },

  [types.EMPLOYEE_OTHER_INFO]: async ({ commit, getters }) => {
    const [ err, values ] = await services.getAdditionalInfo(getters)

    if (!err)
      commit(types.EMPLOYEE_OTHER_INFO, values)

    return [ err, values ]
  },

  [types.EMPLOYEE_SET_OTHER_INFO]: async ({ state, getters, dispatch }, data) => {
    const { customFields, sectionId } = state
    const employeeId = getters.getEmployeeUuid
    const companyId = getters.getCompanyUuid

    const [ err ] = await services.updateAdditionalInfo(data, {
      employeeId, companyId, schema: customFields, sectionId
    })

    if (!err) await dispatch(types.EMPLOYEE_OTHER_INFO)

    return [ err ]
  }
}

export default { state, getters, mutations, actions }
